import type { BRANCHES_LIST_DATA, BRANCHES_LIST_PARAMS } from './types'

import { DEFAULT_PADDING, DEFAULT_WIDTH, generateForAllDevice } from '../const'

export const DEFAULT_BRANCHES_LIST_PARAMS = (): BRANCHES_LIST_PARAMS =>
  generateForAllDevice({ width: DEFAULT_WIDTH(), padding: DEFAULT_PADDING(), hidden: false })

export const DEFAULT_BRANCHES_LIST_DATA = (): BRANCHES_LIST_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'branches-list',
})